import React, { useEffect, useState } from "react";
import useHttpHook from "../../Hooks/HttpHook";
import {
  EventDetailsApi,
  GetEventsByDate,
  UserEventById,
} from "../../utils/ApiConstant";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { showErrorToast } from "../../utils/notify";

const EventListModal = ({ date, handleClose, eventName }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loadingState, setLoadingState] = useState(false);
  const [loadingDate, setLoadingDate] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(date, "-------------------- date ----------------");
    if (date) {
      getEvents();
    }
    console.log(eventName, "-------------- event Name -------------------- ");
    if (eventName) {
      getEvtntDetials();
    }
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getEvtntDetials = async () => {
    try {
      setLoadingState(true);
      const res = await sendRequest(`${UserEventById}${eventName}`, {
        method: "get",
      });
      console.log({ res });
      if (res.status === 1) {
        console.log(res.data);
        setSelectedEvent(res.data);
        setLoadingState(false);
        // setSelectedEvent((prev) => {
        //   return { ...prev, title: capitalizeFirstLetter(prev.title) };
        // });
      }
    } catch (error) {
      setLoadingState(false);
      console.log(error);
    }
  };

  const getEvents = async () => {
    try {
      setLoadingDate(true);
      const res = await sendRequest(`${GetEventsByDate}/${date}`);
      if (res.status === 1) {
        console.log(res.data, "event list");
        setEvents(res.data);
        setLoadingDate(false);
      }
    } catch (error) {
      setLoadingDate(false);
      console.log(error);
    }
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <ModalWrapper
        title="Events"
        // submitText={PromocodeLanguage.EditPromocodeForm.SubmitText}
        CloseModalHandler={handleClose}
        clickHandler={handleClose}
      >
        <>
          {loadingState ? (
            <p>Loading....</p>
          ) : (
            <>
              {date ? (
                <ul>
                  {!loadingDate ? (
                    events && events.length > 0 ? (
                      events?.map((event, index) => {
                        return (
                          <li
                            key={index}
                            onClick={() =>
                              navigate(`/event-details/${event._id}`)
                            }
                          >
                            <Link style={{ color: "blue" }}>
                              {event?.title}
                            </Link>
                          </li>
                        );
                      })
                    ) : (
                      <h4>No Events</h4>
                    )
                  ) : (
                    <p>Loading.....</p>
                  )}
                </ul>
              ) : (
                <>
                  <h3 style={{ textTransform: "capitalize" }}>
                    {selectedEvent?.title}
                  </h3>

                  <p>
                    Start Date:
                    <span>
                      {selectedEvent?.eventTiming?.startDate &&
                        moment(
                          new Date(
                            `${
                              selectedEvent?.eventTiming?.startDate?.split(
                                "T"
                              )[0]
                            }T${selectedEvent?.eventTiming?.startTime}`
                          )
                        ).format("LLL")}
                      {` (${selectedEvent?.eventTiming?.timeZone})`}
                      {/* {selectedEvent?.eventTiming?.startTime && */}
                      {/* ` ( ${moment(new Date(selectedEvent?.eventTiming?.startTime)).tz(selectedEvent.eventTiming.timeZone)})`} */}
                    </span>
                  </p>
                  <p>
                    End Date:
                    <span>
                      {selectedEvent?.eventTiming?.endDate &&
                        moment(
                          new Date(
                            `${
                              selectedEvent?.eventTiming?.endDate?.split("T")[0]
                            }T${selectedEvent?.eventTiming?.endTime}`
                          )
                        ).format("LLL")}
                      {` (${selectedEvent?.eventTiming?.timeZone})`}
                      {/* {selectedEvent?.eventTiming?.endDate &&
                  new Date(selectedEvent.eventTiming.endDate).toDateString()}
                {selectedEvent?.eventTiming?.endTime &&
                  ` ( ${selectedEvent?.eventTiming?.endTime})`} */}
                    </span>
                  </p>
                  <p onClick={() => navigate(`/event-details/${eventName}`)}>
                    <Link style={{ color: "blue" }}>
                      Click Here To Get Event Details
                    </Link>
                  </p>
                </>
              )}
            </>
          )}
        </>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default EventListModal;
